export default __webpack_public_path__ + "game77f53e.jpg";